var map = {
	"./": [
		74105,
		822,
		1037,
		9343,
		1450,
		3241,
		6691
	],
	"./404": [
		32513,
		822,
		9343,
		9218
	],
	"./404.tsx": [
		32513,
		822,
		9343,
		9218
	],
	"./faq": [
		80553,
		822,
		9343,
		5288
	],
	"./faq.tsx": [
		80553,
		822,
		9343,
		5288
	],
	"./grosshandel": [
		46522,
		822,
		9343,
		1450,
		9245
	],
	"./grosshandel.tsx": [
		46522,
		822,
		9343,
		1450,
		9245
	],
	"./impressum": [
		44662,
		822,
		9343,
		7524
	],
	"./impressum.tsx": [
		44662,
		822,
		9343,
		7524
	],
	"./index": [
		74105,
		822,
		1037,
		9343,
		1450,
		3241,
		6691
	],
	"./index.tsx": [
		74105,
		822,
		1037,
		9343,
		1450,
		3241,
		6691
	],
	"./kontakt": [
		8685,
		822,
		1228,
		9343,
		5457
	],
	"./kontakt.tsx": [
		8685,
		822,
		1228,
		9343,
		5457
	],
	"./wissen": [
		27649,
		822,
		9343,
		2239
	],
	"./wissen.tsx": [
		27649,
		822,
		9343,
		2239
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70717;
module.exports = webpackAsyncContext;